import { httpClient } from '../commons/httpClient'

export interface EmployeeSignupValues {
  code: string
  password: string
}

export const getForSave = (code: string): Promise<any> => {
  var encodedCode = encodeURIComponent(code)
  return httpClient.get(`/Account/EligibleEmployee/ForSave?code=${encodedCode}`)
}

const signup = (signup: EmployeeSignupValues): Promise<any> => {
  return httpClient.post('/Account/EligibleEmployee/Create', signup)
}

export default signup
